export const environment = {
    production: false,
    backendUrl: (window as any)['env']['backendUrl'],
    pb24Url: (window as any)['env']['pb24Url'],
    refreshTokenUrl: (window as any)['env']['refreshTokenUrl'],
    maxUploadFileSizeInBytes: (window as any)['env']['maxUploadFileSizeInBytes']
}
